export const STAMMDATEN_FORM_FIELDS = {
  NAME: 'name',
  NICKNAME: 'nickname',
  STREET: 'street',
  ZIP_CODE: 'zipCode',
  CITY: 'city',
  COMPANY_PHONE_COUNTRY_CODE: 'companyPhoneCountryCode',
  COMPANY_PHONE: 'companyPhone',
  COUNTRY_ISO_CODE: 'countryISOCode',
  GLN: 'gln',
  TITLE: 'title',
  LAST_NAME: 'lastName',
  FIRST_NAME: 'firstName',
  EMAIL: 'email',
  CONTACT_PERSON_PHONE_COUNTRY_CODE: 'contactPersonPhoneCountryCode',
  CONTACT_PERSON_PHONE: 'contactPersonPhone',
} as const;
